import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import {
  Link, useLocation, useNavigate, useParams,
} from 'react-router-dom';
import routes from 'app/routes';
import { Button } from 'react-bootstrap5';

import Program from 'components/ProgramBuilder/Program';
import useLoadTopics from 'components/new_ui/Hooks/useLoadTopics';
import useTemplate from 'components/Managers/Templates/utils/useTemplate';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';

import StepTab from 'components/new_ui/Tabs/StepTab';
import Alert from 'components/new_ui/Alerts/alert';

const selectedSteps = (topics, steps) => {
  const arr = [];
  steps.forEach((step, index) => {
    if (step.topic) {
      const topic = topics.find((item) => item.id === step.topic.id);
      if (topic) {
        arr.push({
          position: index + 1,
          topic,
        });
      }
    }
  });
  return arr;
};

export default function OrderTopics({ enterpriseId }) {
  const { templateId } = useParams();

  const { state } = useLocation();
  const [data, setData] = useState((state && state.data) || null);
  const [selectedTopics, setSelectedTopic] = useState((state && state.selectedTopics) || null);
  const template = (state && state.template) || useTemplate(templateId);
  const { topics } = useLoadTopics({ enterprise_id: enterpriseId });

  const [templateAttribute, setTemplateAttribute] = useState(null);
  const navigate = useNavigate();

  const onChange = (value) => {
    setData(value);
  };

  const onContinue = () => {
    const errorMessages = [];
    if (data.programName === '') {
      errorMessages.push('set your Program name');
    }
    if (data.sessionsTopics == null || data.sessionsTopics.length < data.countSessions) {
      errorMessages.push('assign a topic to each step of your Program before you continue');
    }

    if (errorMessages.length > 0) {
      Alert({
        title: 'Build Program',
        text: `You're almost finished! Please ${errorMessages.join(' and ')}.`,
        confirmButtonText: 'Close',
      });
    } else {
      navigate(
        routes.managers.templates.editSummary(templateId),
        {
          state: {
            data,
            selectedTopics,
            template,
          },
        },
      );
    }
  };

  useEffect(() => {
    if (topics === undefined || template === undefined) {
      return;
    }
    if (selectedTopics == null) {
      const selectedTopicsIds = template.attributes.steps.map((step) => step.topic.id);
      setSelectedTopic(topics.filter((topic) => selectedTopicsIds.includes(topic.id)));
    }

    if (topics.length > 0) {
      setTemplateAttribute({
        title: data?.programName || template.attributes.title,
        sessions: data?.countSessions || template.attributes.sessions,
        steps: data?.sessionsTopics || selectedSteps(topics, template.attributes.steps),
      });
    }
  }, [topics, template]);

  return (
    <>
      <StepTab total={3} current={2} />

      <div className="content">
        <section>
          <h1 className="mb-3">Order Selected Topics</h1>

          <p>
            Drag and drop your topics from left to right in any order of your choice.
            Choose a new topic for each session or dig deeper with the same topic for
            multiple sessions. But don’t stress — you will be able to make program changes
            later.
          </p>
        </section>

        {templateAttribute === null && (
          <section>
            <LoadingPlaceholder text="Build program..." />
          </section>
        )}

        {templateAttribute && (
          <>
            <section>
              <Program
                enterpriseId={enterpriseId}
                selectedTopics={selectedTopics}
                templateAttribute={templateAttribute}
                onChange={onChange}
              />
            </section>

            <footer className="d-flex justify-content-between">
              <Link
                to={routes.managers.templates.editChooseTopics(templateId)}
                className="btn btn-outline-primary"
                state={{
                  data,
                  selectedTopics,
                  template,
                }}
              >
                Previous
              </Link>

              <Button
                onClick={onContinue}
              >
                Next
              </Button>
            </footer>
          </>
        )}
      </div>
    </>
  );
}

OrderTopics.propTypes = {
  enterpriseId: PropTypes.number.isRequired,
};
